import * as React from 'react';
const SvgNavigatePrev = props => (
  <svg
    fill="currentColor"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.000599721 12.4894L12.4178 25L15.9381 21.4814L8.96428 15.0027L24.0391 15.0027L24.0391 9.99734L8.96428 9.99734L15.9808 3.56117L12.4178 1.01596e-06L0.000599721 12.4894Z"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgNavigatePrev;
